import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const FIXED_DEPOSIT_LEADS_URL = `${API_URL}/fixed-deposit-leads`

export const service = {
  getFixedDepositLeads: (params: ParamsModel) => {
    return axios.get(FIXED_DEPOSIT_LEADS_URL, {params})
  },
}
